export const PROPERTY_LOAN_PROCESSING_FEE_PERCENTAGE = 1;
export const PROPERTY_LOAN_PROCESSING_FEE_LABEL = `${PROPERTY_LOAN_PROCESSING_FEE_PERCENTAGE}%`;

export const propertyLoanProcessingFee = (amount) =>
  Math.round((Number(amount || 0) * PROPERTY_LOAN_PROCESSING_FEE_PERCENTAGE / 100 + Number.EPSILON) * 100) / 100;

export const propertyLoanNetDisbursement = (amount) =>
  Math.round((Number(amount || 0) - propertyLoanProcessingFee(amount) + Number.EPSILON) * 100) / 100;

export const propertyLoanProcessingFeeTerms = (amount) => ({
  processing_fee: propertyLoanProcessingFee(amount),
  processing_fee_type: "percentage",
  processing_fee_value: PROPERTY_LOAN_PROCESSING_FEE_PERCENTAGE,
});
